<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  classCount: {
    type: [Number, String],
    default: 0
  },
  studentCount: {
    type: [Number, String],
    default: 0
  },
  schoolType: {
    type: String,
    default: ''
  },
  grade: {
    type: [String, Number],
    default: ''
  }
});

// 동적 제목 생성
const displayTitle = computed(() => {
  if (props.title) return props.title;
  
  const schoolTypeText = props.schoolType;
  const gradeText = props.grade ? `${props.grade}학년` : '';
  
  return `${schoolTypeText} ${gradeText} 수준별 AI·디지털 리터러시 기대 성취 수행`.trim();
});
</script>

<template>
  <div class="card mt-2">
    <h5 class="card-title">우리 학교 검사 현황</h5>
    <div class="box-wrap">
        <div class="box">
            <div class="img"><img src="@/assets/images/result/ai/icon_class_lg.png"></div>
            <div class="text">
                <span>검사 학급 수</span>
                <p>{{ classCount }}학급</p>
            </div>                       
        </div>
        <div class="box">
            <div class="img"><img src="@/assets/images/result/ai/icon_student_lg.png"></div>
            <div class="text">
                <span>검사 학생 수</span>
                <p>{{ studentCount }}명</p>
            </div>    
        </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.box-wrap {
    display: flex;
    gap: .5rem;
    padding-top: .5rem;
    .box {
        width: calc((100% - .5rem) / 2 );
        display: flex;
        align-items: center;
        justify-content: center;
        padding: .75rem 0;
        border-radius: .375rem;
        border: 1px solid var(--result-ai-border);
        gap: 1rem;
        .text {
            width: 150px;
            span { font-size: 1rem; display: inline-block; width: 100%; border-bottom: 1px solid var(--result-ai-border); text-align: center;}
            p { font-size: 1.25rem; font-weight: 600; text-align: center; }
        }
       
    }
}
</style>
